import React from "react";
import { Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Skeleton from "react-loading-skeleton";
import { ResponsiveBreadcrumb } from "../../Layout/ResponsiveBreadcrumb";
import { Avatar } from "../../common/Avatar/Avatar";
import { AvatarSkeleton } from "../../common/Avatar/AvatarSkeleton";
import { IIdentity } from "../../../customTypings/user/Identity";

interface UserProfileHeaderProps {
    user: IIdentity | null;
}

export const UserProfileHeader: React.FC<UserProfileHeaderProps> = ({ user }) => {
    return (
        <>
            <Helmet>
                <title>{`User ${user?.displayName}`}</title>
            </Helmet>

            <ResponsiveBreadcrumb
                items={[
                    { text: "Settings", to: "/settings" },
                    { text: "Users", to: "/users" },
                    {
                        text: "User",
                        labelNode: user ? user.displayName : <Skeleton width="6em" />,
                    },
                ]}
            />

            <Row className="mb-3">
                <h1>
                    {user && <Avatar identity={user} size={1.5} />}
                    {!user && <AvatarSkeleton size={1.5} />}
                </h1>
            </Row>
        </>
    );
};
